/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ForumSelectDetailSchoolsSchool.vue?vue&type=template&id=2efd61bc&scoped=true"
import script from "./ForumSelectDetailSchoolsSchool.vue?vue&type=script&setup=true&lang=js"
export * from "./ForumSelectDetailSchoolsSchool.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ForumSelectDetailSchoolsSchool.vue?vue&type=style&index=0&id=2efd61bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efd61bc",
  null
  
)

export default component.exports